/** @jsx jsx */

import * as React from "react";
import { AnyAction } from "redux";
import CustomSelect from "../../CustomSelect";
import Dropdown from "../../Dropdown";
import TextInput from "../../TextInput";
import TypeAhead, { TypeAheadElement } from "../../TypeAhead";
import { css, jsx } from "@emotion/core";
import { familyHistoryStyles } from "../../../styles/components/ongoing/History/familyHistory";


interface IAddedMedicalHistory {
    disease: {
        displayValue: string;
        internalValue: string;
        additionalInfo: any;
    },
    items: Array<{
        age: string;
        comment: string;
        presentDate: string;
        startMonth: string;
        startYear: string;
        tillDate: boolean
    }>,
    q: {
        displayValue: string;
        internalValue: Array<string>;
    },
    updatingMethod: string;
    validSection: boolean;
}

interface IMedicalHistoryProps {
    onTypeAheadChange: (input: string, typeAheadConfig: any) => Promise<any>;
    handleItemChange(updatedItem: any, index: number): void;
    listItems: any[];
}

interface IMedicalHistoryState {
    shouldShowTypeAhead: boolean;
    isReadOnly: boolean;
    selectedItems: Array<IAddedMedicalHistory>;
    typeAheadVal: string;
}



export class MedicalHistory extends React.Component<IMedicalHistoryProps, IMedicalHistoryState> {


    constructor(props: IMedicalHistoryProps) {
        super(props);
        const selectedItems = [...props.listItems.map(({ item }) => item)];
        this.state = {
            shouldShowTypeAhead: selectedItems.length <= 0,
            isReadOnly: selectedItems.length > 0,
            typeAheadVal: "",
            selectedItems
        }
    }

    save = () => {
        this.state.selectedItems.forEach((item, index) => {
            this.props.handleItemChange(item, index);
        });
        this.setState({ isReadOnly: true, shouldShowTypeAhead: false });
    }

    onTypeAheadSelect = (elem: TypeAheadElement, idx?: number, noOfKeystrokes?: number, event?: any, searchKeyword?: string) => {
        const newlyAddedItem: IAddedMedicalHistory = {
            disease: {
                displayValue: elem.label,
                internalValue: elem.value,
                additionalInfo: elem.additionalInfoLabel
            },
            items: [{
                age: undefined,
                comment: undefined,
                presentDate: undefined,
                startMonth: undefined,
                startYear: undefined,
                tillDate: false
            }],
            q: {
                displayValue: elem.label,
                internalValue: [elem.value],
            },
            updatingMethod: "TYPE_AHEAD",
            validSection: true
        }

        const selectedItems = this.state.selectedItems;
        selectedItems.push(newlyAddedItem);
        this.setState({ selectedItems, shouldShowTypeAhead: false });
    }

    onTypeAheadChange = (input: string) => {
        this.setState({ typeAheadVal: input });
        const typeAheadConfig = {
            "source": "MAVERICK",
            "url": "/maverick/care/disease_catalogue",
            "appendQueryString": true,
            "highlightOn": "available",
            "valueKey": "name",
            "labelKey": "name",
            "inputParam": "q",
            "resultMapper": [{
                "internalValue": "internalValue",
                "displayValue": "displayValue"
            }],
            "otherKeysMapping": {
                "on-properties": "id,name",
                "result-size": 20
            },
            "internalKey": "id",
            "code": "uCode"
        }
        return this.props.onTypeAheadChange(input, typeAheadConfig);
    }

    onRelationshipChange = (value: boolean, ObjectIndex: number, itemIndex: number) => {
        const selectedItems: IAddedMedicalHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].items[itemIndex].tillDate = value;
            this.setState({ selectedItems });
        }
    }


    onCommentsChange = (event: React.ChangeEvent<HTMLInputElement>, ObjectIndex: number, itemIndex: number) => {
        const value: string = event.target.value;
        const selectedItems: IAddedMedicalHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].items[itemIndex].comment = value;
            this.setState({ selectedItems });
        }
    }

    onAgeChange = (event: React.ChangeEvent<HTMLInputElement>, ObjectIndex: number, itemIndex: number) => {
        const value: string = event.target.value;
        const selectedItems: IAddedMedicalHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex]) {
            selectedItems[ObjectIndex].items[itemIndex].age = value;
            this.setState({ selectedItems });
        }
    }


    removeDisease = (ObjectIndex: number, itemIndex: number) => {
        const selectedItems: IAddedMedicalHistory[] = this.state.selectedItems;
        if (selectedItems[ObjectIndex] && itemIndex > 0) {
            selectedItems[ObjectIndex].items.splice(itemIndex, 1);
            this.setState({ selectedItems });
        } else if (selectedItems[ObjectIndex] && itemIndex === 0) {
            selectedItems.splice(ObjectIndex, 1);
            this.setState({ selectedItems });
        }
    }

    addNewDisease = () => {
        this.setState({ shouldShowTypeAhead: true });
    }

    edit = () => {
        this.setState({ shouldShowTypeAhead: true, isReadOnly: false });
    }
    render() {
        const { shouldShowTypeAhead, isReadOnly, selectedItems, typeAheadVal } = this.state;
        return <div>
            <button css={familyHistoryStyles.editBtn} onClick={this.edit}>
                <span className="glyphicon glyphicon-pencil" css={familyHistoryStyles.editIcon}></span>
                <span>Edit</span>
            </button>
            {shouldShowTypeAhead &&
                <div css={familyHistoryStyles.commonlyUsedComntainer}>
                    <div>
                        <div>COMMONLY USED</div>
                        <div></div>
                    </div>
                    <div css={familyHistoryStyles.typeAheadContainer}>
                        <TypeAhead value={typeAheadVal} placeholder="Select Disease Name" onTypeAheadChange={this.onTypeAheadChange}
                            onTypeAheadSelect={this.onTypeAheadSelect} />
                    </div>
                </div>
            }
            {!isReadOnly &&
                <div>
                    {
                        selectedItems.map((item: IAddedMedicalHistory, ObjectIndex: number) => {
                            let { items } = item;
                            return <div css={familyHistoryStyles.selectedDiseaseRow}>
                                <div css={familyHistoryStyles.verticalMiddle}>{item.disease.displayValue}</div>
                                <div css={familyHistoryStyles.itemsContainer}>
                                    {
                                        items.map(({ comment, tillDate, presentDate, startMonth, startYear, age }, itemIndex) => {
                                            return (
                                                <div css={familyHistoryStyles.itemsWrapper}>
                                                    <div>
                                                        <div css={familyHistoryStyles.groupLabel}>Onset Age</div>
                                                        <div css={familyHistoryStyles.sectionElement}>
                                                            <TextInput placeholder="Onset Age" value={age} onChange={(e) => this.onAgeChange(e, ObjectIndex, itemIndex)} type="number" />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div css={familyHistoryStyles.groupLabel}>Relationship</div>
                                                        <div css={familyHistoryStyles.relationShipItem}>
                                                            <button onClick={() => this.onRelationshipChange(true, ObjectIndex, itemIndex)} css={tillDate ? familyHistoryStyles.selectedBtn : familyHistoryStyles.relationshipBtns}>Ongoing</button>
                                                            <button onClick={() => this.onRelationshipChange(false, ObjectIndex, itemIndex)} css={!tillDate ? familyHistoryStyles.selectedBtn : familyHistoryStyles.relationshipBtns}>Past</button>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div css={familyHistoryStyles.groupLabel}>Comments (Optional)</div>
                                                        <TextInput placeholder="Comments" value={comment} onChange={(e) => this.onCommentsChange(e, ObjectIndex, itemIndex)} />
                                                    </div>
                                                    <div css={familyHistoryStyles.actionWrapper}>
                                                        <div>
                                                            <span className="glyphicon glyphicon-trash" css={familyHistoryStyles.icons} onClick={() => this.removeDisease(ObjectIndex, itemIndex)}></span>

                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
            }

            {isReadOnly &&
                <div>
                    {
                        selectedItems.map((item: IAddedMedicalHistory, ObjectIndex: number) => {
                            let { items } = item;
                            return <div css={familyHistoryStyles.readOnlyRow}>
                                <div css={familyHistoryStyles.verticalMiddle}>{item.disease.displayValue}</div>
                                <div css={familyHistoryStyles.itemsContainer}>
                                    {
                                        items.map(({ comment, tillDate, presentDate, startMonth, startYear, age }, itemIndex) => {
                                            return (
                                                <div css={familyHistoryStyles.itemsWrapperReadOnly}>
                                                    {age && <div>{age} | </div>}
                                                    {tillDate && <div>{tillDate && "Present"} | </div>}
                                                    {comment && <div>{comment} | </div>}
                                                    {startMonth && startYear &&
                                                        <div>{startMonth}-{startYear}</div>
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
            }

            {!isReadOnly
                &&
                <div css={familyHistoryStyles.bottonCta}>
                    <button onClick={this.addNewDisease} css={familyHistoryStyles.transparentBtn}><span className="glyphicon glyphicon-plus-sign" css={familyHistoryStyles.icons}></span> Add New</button>
                    {selectedItems.length > 0 &&
                        <button css={familyHistoryStyles.selectedBtn} onClick={this.save}>Save</button>
                    }
                </div>
            }

        </div>
    }


}